import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  notification:
    'Changing payment settings will update for all devices at this Site',
  terminal: 'Terminal',
})
